export default "__VITE_ASSET__Dl_lCItl__ 400w, __VITE_ASSET__BBRekFXv__ 800w, __VITE_ASSET__BHjDYwbi__ 1200w";